module.exports = __webpack_public_path__ + "static/media/white-arrow.6c621757.svg";